module.exports = __webpack_public_path__ + "img/ring_g_0_1_0@3x.d3a7bc70.png";